import React, { PureComponent } from "react";

import LayoutDropdown from "./LayoutDropdown";

import "./index.scss";

class LayoutNav extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {}

  render() {
    return (
      <div className="layout-nav-container">
        <LayoutDropdown
          page={this.props.page}
          setIsDashboardRerendering={this.props.setIsDashboardRerendering}
          setIsReportRerendering={this.props.setIsReportRerendering}
          setIsChartRerendering={this.props.setIsChartRerendering}
          systemID={this.props.systemID}
          tagsList={this.props.tagsList}
          onToggleCollapsedNav={this.props.onToggleCollapsedNav}
          isLeftSideNavOpen={this.props.isLeftSideNavOpen}
          setIsAddWidgetFormOpen={this.props.setIsAddWidgetFormOpen}
          onWidgetAction={this.props.onWidgetAction}
          isAddWidgetFormOpen={this.props.isAddWidgetFormOpen}
          setIsAddLayoutFormOpen={this.props.setIsAddLayoutFormOpen}
          isAddLayoutFormOpen={this.props.isAddLayoutFormOpen}
          setIsEditLayoutFormOpen={this.props.setIsEditLayoutFormOpen}
          isEditLayoutFormOpen={this.props.isEditLayoutFormOpen}
          layoutId={this.props.layoutId}
          autogenerate={this.props.autogenerate}
          setAutogenerate={this.props.setAutogenerate}
        />
      </div>
    );
  }
}

export default LayoutNav;
